import { render, staticRenderFns } from "./PaymentProcessCard.vue?vue&type=template&id=2328ce66&"
import script from "./PaymentProcessCard.vue?vue&type=script&lang=js&"
export * from "./PaymentProcessCard.vue?vue&type=script&lang=js&"
import style0 from "./PaymentProcessCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports